import {onFind} from "../libs/@elements/init-modules-in-scope";
import {on, closest, find, findIn} from "../libs/@elements/dom-utils";

export function init () {
    /* add hidden input value on filter collapse */
    onFind('.js-product-grid__filter-collapse', function (item) {
        on('click', function () {
            let target = find(item.getAttribute('data-bs-target'));
            let input = findIn('.js-product-grid__input', closest('.js-product-grid__filter-collapse__container', target));

            target.addEventListener('hidden.bs.collapse', function () {
                input.value = "false"
            });
            target.addEventListener('shown.bs.collapse', function () {
                input.value = "true"
            });
        }, item);
    });
}